var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"check-mark",class:{ 'check-mark--checked': _vm.checked }},[_c('check-icon',{staticClass:"check-mark__icon"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }